import { animate, inView, stagger, delay } from "motion"
import gsap from "gsap"
import { SplitText } from "gsap/SplitText";

document.addEventListener('DOMContentLoaded',()=>{
    inView(".hero__heading.--southwark ", ({target})=>{
        delay(() => {
            animate(".hero__heading.--southwark .title",
                { opacity:[0, 1], y: [100, 0] },
                {
                    delay: stagger(0.2), //  4 span 
                    duration: 0.5,
                    easing:"easeInOut",
            });
        },0.2) // Until above animation finish
    });
    inView(".hero__desc", ({target})=>{
        animate(target,
            { opacity: [0,1], y: [100, 0] },
            {
                duration: 0.5,
                easing:"easeInOut",
        });
        return () => animate(target, { opacity: 0, y: -100 });
    });

    // Hero Heading
    const mainHeroHeading = document.querySelector('.mainHeroHeading');
    if(mainHeroHeading){
        let split = SplitText.create(mainHeroHeading,{
        mask:'words',
        wordsClass:"title"
        });
        inView(".mainHeroHeading", ({target})=>{
        delay(() => {
            animate(".mainHeroHeading .title",
                { opacity:[0, 1], y: [100, 0] },
                {
                    delay: stagger(0.2), //  4 span 
                    duration: 0.5,
                    easing:"easeInOut",
            });
        },0.2) // Until above animation finish
        });
    }
    // Hero Desc
    inView(".mainHero", ({target})=>{
        animate(".mainHero__desc",
            { opacity: [0,1], y: [100, 0] },
            {
                duration: 0.5,
                easing:"easeInOut",
        });
        return () => animate(".mainHero__desc", { opacity: 0, y: -100 });
    });


    inView(".anim-slide-up-stagger-divs div", ({target})=>{
        animate(target,
            { opacity: [0,1], y: [100, 0] },
            {
                delay: stagger(0.3),
                easing:"ease-in-out",
        });

    return () => {};
    });

    document.querySelectorAll(".anime-scale-img  img").forEach((item) => {
    scroll(animate(item, {scale: [1, 1.1, 1.1, 1.1] }, { ease: easing }), {
        target: item,
        offset: ["start end", "center center", "center center", "end start"], 
        // offset: ["start start", "end end", "start 0.8", "end 0.9"],
    });
    scroll(animate(item, {
        opacity: [1, 0] },{ easing: "ease-in-out" }), {
        target: item,
        offset: ["start start", "end start"],
    })
    })

    inView(".anim-slide-up", ({target})=>{
        animate(target,
            { opacity: [0,1], y: [100, 0] },
            {  duration: 0.5,easing: [0.17, 0.55, 0.55, 1],});
        return () => null;
    });

})
